<p>edit-company-assessment-group works!</p>
